import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { JobProvider } from "./components/JobContext";
import { HelmetProvider } from "react-helmet-async"; // ✅ ADD THIS

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider> {/* ✅ Wrap entire app */}
    <JobProvider>
      <App />
    </JobProvider>
  </HelmetProvider>
);